/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Meta_TitleInputs */

const de_commons_meta_title = /** @type {(inputs: Commons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`waipu.tv - Fernsehen wie noch nie.`)
};

/** @type {(inputs: Commons_Meta_TitleInputs) => LocalizedString} */
const en_commons_meta_title = de_commons_meta_title;

/**

* @param {Commons_Meta_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_meta_title = /** @type {((inputs?: Commons_Meta_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Meta_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_meta_title(inputs)
	return en_commons_meta_title(inputs)
});